/*
==========================================================
Ankur Product Video v2.0
Autoplay + Auto Fit
==========================================================
*/

(function () {
    'use strict';

    function initProductVideos() {

        document.querySelectorAll('.product-single__media').forEach(function (media) {

            const video = media.querySelector('video');

            if (!video) return;

            // ----------------------------------
            // Autoplay
            // ----------------------------------

            video.muted = true;
            video.autoplay = true;
            video.loop = true;
            video.playsInline = true;

            const playPromise = video.play();

            if (playPromise !== undefined) {
                playPromise.catch(() => {});
            }

            // ----------------------------------
            // Auto Fit
            // ----------------------------------

            media.classList.add('ankur-product-video');

            // Remove Ella's dynamic height
            media.style.paddingTop = '';

        });

    }

    document.addEventListener('DOMContentLoaded', initProductVideos);

    window.addEventListener('load', initProductVideos);

    document.addEventListener('click', function () {
        setTimeout(initProductVideos, 200);
    });

    document.addEventListener('change', function () {
        setTimeout(initProductVideos, 200);
    });

})();